module.exports = function(done, value){
  return {value: value, done: !!done};
};


//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/core-js/modules/_iter-step.js
// module id = 211
// module chunks = 0 1 2 3 5 6 7 8 9 10